import { render } from "./LeadsTracker.vue?vue&type=template&id=63c3b5d6&scoped=true"
import script from "./LeadsTracker.vue?vue&type=script&lang=js"
export * from "./LeadsTracker.vue?vue&type=script&lang=js"

import "./LeadsTracker.vue?vue&type=style&index=0&id=63c3b5d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c3b5d6"]])

export default __exports__